exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".active-quote-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.list-group-item {\n  color: black;\n  text-decoration: none;\n  transition: 0.5s; }\n\n.list-group-item:hover {\n  background-color: gray;\n  transition: 1s;\n  text-decoration: none; }\n", ""]);

